import { NgModule } from '@angular/core';
import { FuseUtilsService } from '@fuse/services/utils/utils.service';
import {GoogleMapsAPIWrapper} from '@agm/core';

@NgModule({
    providers: [
        GoogleMapsAPIWrapper,
        FuseUtilsService
    ]
})
export class FuseUtilsModule
{
    /**
     * Constructor
     */
    constructor(private _fuseUtilsService: FuseUtilsService)
    {
    }
}
